import React from "react";
import * as ReactDOMClient from "react-dom/client";
import Control from "./control/control";
export default class ReactHook {
    static hookup(hud, Node, props, controller) {
        const hudRoot = ReactDOMClient.createRoot(hud);
        hudRoot.render(React.createElement(Control, { controller: controller },
            React.createElement(Node, Object.assign({}, props))));
    }
}
